import React, { useState, useRef, useContext, useEffect, createRef, useLayoutEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import Modal from '../core/Modal';
import { PortalDataContext } from '../PortalContext';
import { BasicText, Button, Heading4 } from '../Styles';
import { View } from 'react-native';
import styled, { useTheme } from 'styled-components/native';
import Util from '../core/Util';

function upload(f, callback, portalDataContext) {
	const reader = new FileReader();
	reader.onload = function (e) {
		let fileContents = "";
        if(e.target.result != undefined){
            fileContents = e.target.result + "";
        }
		const base64 = fileContents.substring(fileContents.lastIndexOf(",") + 1)

		const upload = { filename: f.name, base64: base64, lastModified: f.lastModified, storeIn: "db" };
        
        fetch(Util.getHost() + "/api/v1/portal/uploadInvoice", {
            method: "POST",
            body: JSON.stringify({
				authToken: portalDataContext.authToken.code,
                upload: upload
            })
        }).then((j) => j.json()).then((r) => {
			if (callback) {
				callback(f, r.result);
			}
		});

	}
	reader.readAsDataURL(f);
}

const File = ({label = "Drop Files/Attachments", beforeUpload = undefined, onUpload = undefined}) => {
	const theme = useTheme();
	const [activeDrag, setActiveDrag] = useState(false);
	const fileContainerRef = useRef(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);
	const portalDataContext = useContext(PortalDataContext);

	useLayoutEffect( (a,b,c)=>{
		if (fileContainerRef.current != null){
			fileContainerRef.current.parentElement.parentElement.ondragover = (e)=>executeMaxAreaDropAction(e);
			fileContainerRef.current.parentElement.parentElement.ondragleave = (e)=>executeMaxAreaDropAction(e);
			fileContainerRef.current.parentElement.parentElement.ondrop = (e)=>executeMaxAreaDropAction(e);
		}
	});

    const openModal = (content) => {
        setModalContent(content);
        setModalVisible(true);
    }

	const handleDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();

        let file = null;
        if(e.dataTransfer.files != undefined){
            file = e.dataTransfer.files[0];
        }
        
		if (beforeUpload) {
			beforeUpload();
		}

		upload(file, (file, result) => {
			onUpload && onUpload(result);
		}, portalDataContext);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const openFile = (e) => {
        const fileInput = document.createElement('input');
		fileInput.type = 'file';
		fileInput.onchange = (e) => {
			let file = null;
			if(e.currentTarget.files != undefined){
				file = e.currentTarget.files[0];
			}

			upload(file, (file, result) => {
				onUpload && onUpload(result);
			}, portalDataContext);
		};

		fileInput.click();
	};

	const executeMaxAreaDropAction = (e) =>{
		e.preventDefault(); 
		e.stopPropagation();
		if(e.type == "dragover"){
			setActiveDrag(true);
		} else if(e.type == "dragleave"){
			const parentLocation = e.currentTarget.getBoundingClientRect();

			if(e.x < parentLocation.left || e.x > parentLocation.right || 
				e.y < parentLocation.top || e.y > parentLocation.bottom){
					setActiveDrag(false);
				}
		} else if(e.type == "drop"){
			setActiveDrag(false);
			handleDrop(e);
		}
	}

	let dragStyle = {};

	if(activeDrag){
		dragStyle = {
			background: "rgba(0,0,0,0.4)",
			color: "#e6e6e6",
			boxShadow: "0 0 20px rgb(0 0 0)"
		};
	}

	return <DropArea ref={fileContainerRef}
		onDrop={(e) => handleDrop(e)}
		onDragLeave={(e) => handleDragLeave(e)}
		onDragOver={(e) => handleDragOver(e)}
		style={dragStyle}>
        <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
            {modalContent}
        </Modal>
		<DropAreaContent>
			<Heading4>{activeDrag == true? "Drop To Upload" : label}</Heading4>
			<button onClick={openFile} style={{...pretendButtonStyles, ...{backgroundColor: theme.brandColor, fontFamily: theme.fontFamily, padding: theme.input? theme.input.padding : 10}}}>
				<BasicText colour="white">Browse Files</BasicText>
			</button>
		</DropAreaContent>
	</DropArea>
}

const DropArea = styled.View`
	border: dotted #aaaaaa;
	border-width: 5px;
	color: #cccccc;
	font-size: 20px;
	padding: 10px;
`;

const DropAreaContent = styled.View`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const pretendButtonStyles = {
    color: "white",
    backgroundColor: "initial",
    borderRadius: 5,
    fontFamily: "Red Hat Display",
	marginTop: 10,
	cursor: "pointer",
	borderWidth: 0
}

export default File;